import { Fragment } from "react";
import HUNGRYBOX from "../assests/Hungrybox.jpg";
import CartButton from "./CartButton";
import classes from "./Header.module.css";

const Header = (props) => {
  return (
    <Fragment>
      <header className={classes.header}>
        <h1>HUNGRYBOX DHAKA</h1>
        <CartButton onClick={props.onShowNumber} />
      </header>
      <div className={classes["main-image"]}>
        <img src={HUNGRYBOX} alt="HUNGRYBOX" />
      </div>
    </Fragment>
  );
};
export default Header;
